class QuickFilters extends HTMLElement {
  constructor() {
    super();
    this.controller = new AbortController();
    this.filterParamName = null;
    this.isCollectionsMode = false;
    this.sectionId = null;
    this.loadingDiv = null;
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('[data-quick-filters-option]');
    this.filterParamName = this.dataset.paramName;
    this.isCollectionsMode = this.dataset.mode === 'collections';
    this.sectionId = this.dataset.sectionId;

    if (this.isCollectionsMode) {
      this.syncFromUrlCollections();
    } else {
      this.syncFromUrl();
    }

    this.bindEvents();

    document.addEventListener('load-more:success', () => {
      this.loadingDiv = document.querySelector('[data-grid-loading]');
      if (this.loadingDiv) this.loadingDiv.style.display = 'none';
    });
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  syncFromUrl() {
    const url = new URL(window.location.href);
    const activeValues = url.searchParams.getAll(this.filterParamName);

    this.buttons.forEach((button) => {
      const value = button.dataset.quickFilterParamValue;

      if (!value) {
        button.classList.toggle('underline', activeValues.length === 0);
      } else {
        button.classList.toggle('underline', activeValues.includes(value));
      }
    });
  }

  syncFromUrlCollections() {
    const url = new URL(window.location.href);
    const activeHandle = url.searchParams.get('collection');
    this.setActiveCollection(activeHandle);

    if (activeHandle) {
      this.fetchAndRenderCollection(activeHandle);
    }
  }

  bindEvents() {
    const { signal } = this.controller;

    this.buttons.forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          if (this.isCollectionsMode) {
            this.handleCollectionClick(button);
            return;
          }

          const paramName = button.dataset.quickFilterParamName;
          const paramValue = button.dataset.quickFilterParamValue;

          if (!paramName) {
            this.navigate(this.removeFilter(this.filterParamName));
            return;
          }

          const url = new URL(window.location.href);
          const currentValues = url.searchParams.getAll(paramName);

          if (currentValues.includes(paramValue)) {
            this.navigate(this.removeFilter(paramName, paramValue));
          } else {
            this.navigate(this.applyFilter(paramName, paramValue));
          }
        },
        { signal }
      );
    });
  }

  handleCollectionClick(button) {
    const handle = button.dataset.collectionHandle;
    const url = new URL(window.location.href);

    if (!handle) {
      url.searchParams.delete('collection');
      history.pushState({}, '', url.toString());
      this.setActiveCollection(null);
      this.fetchAndRenderCollection('all');
    } else {
      url.searchParams.set('collection', handle);
      history.pushState({}, '', url.toString());
      this.setActiveCollection(handle);
      this.fetchAndRenderCollection(handle);
    }
  }

  setActiveCollection(activeHandle) {
    this.buttons.forEach((button) => {
      const handle = button.dataset.collectionHandle;
      if (!handle) {
        button.classList.toggle('underline', !activeHandle);
      } else {
        button.classList.toggle('underline', handle === activeHandle);
      }
    });
  }

  async fetchAndRenderCollection(handle) {
    const loadMore = document.querySelector('load-more');
    if (!loadMore) return;


    const productGrid = loadMore.querySelector('[data-product-grid]');
    if (productGrid) productGrid.style.opacity = '0.5';

    try {
      const response = await fetch(
        `/collections/${handle}?sections=${this.sectionId}`
      );
      const data = await response.json();
      const html = data[this.sectionId];

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newLoadMore = doc.querySelector('load-more');

      if (newLoadMore) {
        loadMore.replaceWith(newLoadMore);

        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('load-more:success'));
        }, 5000);
      }
    } catch {
      if (productGrid) productGrid.style.opacity = '1';
    }
  }

  applyFilter(paramName, paramValue) {
    const url = new URL(window.location.href);
    url.searchParams.delete(paramName);
    url.searchParams.set(paramName, paramValue);
    return url;
  }

  removeFilter(paramName, paramValue) {
    const url = new URL(window.location.href);

    if (!paramValue) {
      url.searchParams.delete(paramName);
    } else {
      const values = url.searchParams
        .getAll(paramName)
        .filter((v) => v !== paramValue);
      url.searchParams.delete(paramName);
      values.forEach((v) => url.searchParams.append(paramName, v));
    }

    return url;
  }

  navigate(url) {
    window.location.href = url.toString();
  }
}

if (!customElements.get('quick-filters')) {
  customElements.define('quick-filters', QuickFilters);
}
